import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { PublicAccount, PublicAccountLog } from "models";

export interface PublicAccountWithApiKey extends PublicAccount {
  api_key?: string;
}

const component = "AccessKeysDashboard";

export const AccessKeysDashboardQueryKeys = {
  accounts: backendQueryKey<PublicAccountWithApiKey[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/publicapi/account/list" }),
  logs: backendQueryKey<PublicAccountLog[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/publicapi/account/logs" })
};
